import axios from "axios";
import qs from "qs";

const axiosInstance = axios.create({
  baseURL: "https://ectech-software.com.ar",
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  }, // Base URL configurada
});

export const login = async (credentials) => {
  

  // Convertir los datos a x-www-form-urlencoded
  const formData = qs.stringify({
    username: credentials.email,
    password: credentials.password,
  });

  try {
    const response = await axiosInstance.post(
      "/api/auth/login",
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded", // Header igual a Postman
        },
      }
    );
    
    return response.data;
  } catch (error) {
    console.error("Error de autenticación:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Método para manejar el refresh token
export const refreshToken = async () => {
  try {
    const token = localStorage.getItem("refreshToken"); // Obtener refresh token del localStorage
    if (!token) throw new Error("No refresh token found");

    const response = await axiosInstance.post(
      "/api/auth/refresh",
      { token }, 
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const { accessToken, refreshToken: newRefreshToken } = response.data;

    // Actualizar tokens en el localStorage
    localStorage.setItem("accessToken", `${accessToken}`);
    localStorage.setItem("refreshToken", newRefreshToken);

    return response.data;
  } catch (error) {
    console.error("Error al refrescar el token:", error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};


// Métodos HTTP
export const get = async (url, config = {}) => {
  const accessToken = localStorage.getItem("accessToken");
  const headers = {

    ...config.headers, // Combina los headers existentes con el de autorización
    'Content-Type': 'application/json; charset=UTF-8',
    Authorization: accessToken,
  };

  return axiosInstance.get(url, { ...config, headers });
};


export const put = async (url, data, config = {}) => {
  const accessToken = localStorage.getItem("accessToken");
  const headers = {
    ...config.headers, // Combina los headers existentes con el de autorización
    Authorization: accessToken,
  };

  return axiosInstance.put(url, data, { ...config, headers });
};


export const post = async (url, data, config = {}) => {
  const accessToken = localStorage.getItem("accessToken");
  const headers = {
    ...config.headers, // Combina los headers existentes con el de autorización
    Authorization: accessToken,
  };

  return axiosInstance.post(url, data, { ...config, headers });
};

export const del = async (url, config = {}) => {
  const accessToken = localStorage.getItem("accessToken");
  const headers = {
    ...config.headers,
    Authorization: accessToken,
  };

  return axiosInstance.delete(url, { ...config, headers });
};

export default axiosInstance;
